import React from "react";
import { Link } from "react-router-dom";
import { Globe, CheckCircle2 } from "lucide-react";
import { waLink } from "@/lib/api";

const COUNTRIES = ["USA", "UK", "UAE", "Singapore", "Canada", "Australia"];

export default function NRICorner() {
  return (
    <div data-testid="page-nri-corner">
      <section className="bg-brand-navy text-white">
        <div className="container-x py-20 md:py-28 grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-8">
            <div className="eyebrow !text-brand-cyan">NRI Corner</div>
            <h1 className="mt-3 font-display text-4xl md:text-6xl font-bold leading-tight">
              Managing Chennai property from abroad should not depend on luck or relatives.
            </h1>
            <p className="mt-5 text-white/80 max-w-2xl">
              Hi-Tech Realty gives NRIs a trusted local property team for inspection, rental management, maintenance coordination, tax reminders and documentation support.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/contact" className="btn-cyan" data-testid="nri-book">Book NRI Property Consultation</Link>
              <a href={waLink("Hi Hi-Tech Realty, I am an NRI and want to manage my Chennai property.")}
                 target="_blank" rel="noreferrer" className="btn-whatsapp" data-testid="nri-whatsapp">Chat on WhatsApp</a>
            </div>
          </div>
          <div className="lg:col-span-4">
            <div className="bg-white text-brand-slate p-6 border-l-4 border-brand-cyan">
              <div className="eyebrow">Owners Across</div>
              <div className="mt-4 grid grid-cols-2 gap-3">
                {COUNTRIES.map((c) => (
                  <div key={c} className="flex items-center gap-2 text-sm font-semibold text-brand-navy"><Globe size={16} className="text-brand-cyan" /> {c}</div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-pad">
        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <div className="eyebrow">NRI Pain Points</div>
            <h2 className="mt-3 font-display text-3xl md:text-4xl font-bold text-brand-navy">What keeps NRIs awake at night.</h2>
            <ul className="mt-6 space-y-3 text-sm text-brand-slate/85">
              {[
                "Midnight tenant calls and unverified repair requests",
                "Property tax, EB and society dues piling up unnoticed",
                "Vacant plots and homes vulnerable to encroachment",
                "Document delays and POA bottlenecks",
                "Lack of transparent reports from local contacts",
              ].map((t) => <li key={t} className="flex items-start gap-2"><CheckCircle2 size={16} className="text-brand-cyan mt-0.5" />{t}</li>)}
            </ul>
          </div>
          <div>
            <div className="eyebrow">What We Manage</div>
            <h2 className="mt-3 font-display text-3xl md:text-4xl font-bold text-brand-navy">A full local team — without the local stress.</h2>
            <ul className="mt-6 space-y-3 text-sm text-brand-slate/85">
              {[
                "Inspection reports with geo-tagged photos & videos",
                "Tenant sourcing, screening and onboarding",
                "Rent collection, deductions and monthly statements",
                "Maintenance ticketing and vendor coordination",
                "Tax / EB / society dues reminders & assistance",
                "POA and documentation coordination",
              ].map((t) => <li key={t} className="flex items-start gap-2"><CheckCircle2 size={16} className="text-brand-cyan mt-0.5" />{t}</li>)}
            </ul>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {[
            { n: "01", t: "Remote Onboarding", b: "Submit details and documents via WhatsApp or email. We schedule a video walkthrough and inspection." },
            { n: "02", t: "Local Field Presence", b: "Our Chennai team visits, documents and reports. You see every update in your owner dashboard." },
            { n: "03", t: "Transparent Reporting", b: "Monthly statements, agreement reminders and tax / EB / society alerts — across time zones." },
          ].map((s) => (
            <div key={s.n} className="card-flat p-7">
              <div className="font-display text-3xl text-brand-cyan font-bold">{s.n}</div>
              <div className="mt-3 font-display text-2xl text-brand-navy font-bold">{s.t}</div>
              <p className="mt-2 text-sm text-brand-slate/80 leading-relaxed">{s.b}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
